module.exports = __webpack_public_path__ + "static/media/YF48_2.751480ef.jpg";